/** Utilities */
import RenderTabs2 from "../../../../../../components/ui/tabs/RenderTabs2";
import UnderConstruction from "../../../../../../components/ui/underConstruction/UnderConstruction";
import Invoice from "./features/ContractInvoice/ContractInvoice";
import Schedule from "./features/ContractSchedule/ContractSchedule";


const Invoices = () => {

  const tabs = [
  
    {   
        sMenuItemCaption: "Invoices",
        component: <Invoice />,
        isDynamic: false
    },
    {   
        sMenuItemCaption: "Schedule",
       component: <Schedule />,
        isDynamic: false
    },
]
  return (
    <>
      <div className="row gap-4">
        {/* <RenderTabs2 tabs={tabs} /> */}
        <UnderConstruction />
      </div>
    </>
  );
};
export default Invoices;
